import { InfoCircleOutlined, MoreOutlined } from "@ant-design/icons";
import { Card, Col, Row, Table } from "antd";
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  ComposedChart,
  LabelList,
  Legend,
  PieChart,
  Pie,
  Cell,
} from "recharts";

import React from "react";
import HeaderCompo from "../../component/Header";
import powerBiImage1 from '../../assets/powerBiImage1.png'
import powerBiImage2 from '../../assets/powerBiImage2.png'

import powerBiImage3 from '../../assets/powerBiImage3.png'
import powerBiImage4 from '../../assets/powerBiImage4.png'
import powerBiImage5 from '../../assets/powerBiImage5.png'
import powerBiImage6 from '../../assets/powerBiImage6.png'

const data = [
  { month: "Mar 2025", net: 12, gcr: 2.15 },
  { month: "Apr 2025", net: 25, gcr: 5.86 },
  { month: "May 2025", net: 48, gcr: 6.17 },
  { month: "Jun 2025", net: 57, gcr: 7.09 },
  { month: "Jul 2025", net: 70, gcr: 5.49 },
  { month: "Aug 2025", net: 98, gcr: 5.95 },
  { month: "Sep 2025", net: 110, gcr: 6.55 },
  { month: "Oct 2025", net: 130, gcr: 5.86 },
  { month: "Nov 2025", net: 150, gcr: 6.13 },
  { month: "Dec 2025", net: 168, gcr: 6.92 },
  { month: "Jan 2026", net: 65, gcr: 6.47 },
];
const unitsData = [
  { month: "Mar", net: 813, generic: 20 },
  { month: "Apr", net: 838, generic: 46 },
  { month: "May", net: 806, generic: 100 },
  { month: "Jun", net: 823, generic: 120 },
  { month: "Jul", net: 874, generic: 161 },
  { month: "Aug", net: 806, generic: 206 },
  { month: "Sep", net: 880, generic: 240 },
  { month: "Oct", net: 907, generic: 260 },
  { month: "Nov", net: 761, generic: 300 },
  { month: "Dec", net: 907, generic: 357 },
  { month: "Jan", net: 467, generic: 407 },
];
const onestopData = [
  { month: "Mar 2025", onestop: 1.78, rtl2: 1.19 },
  { month: "Apr 2025", onestop: 1.86, rtl2: 1.28 },
  { month: "May 2025", onestop: 1.45, rtl2: 1.25 },
  { month: "Jun 2025", onestop: 1.72, rtl2: 1.35 },
  { month: "Jul 2025", onestop: 1.42, rtl2: 1.34 },
  { month: "Aug 2025", onestop: 1.41, rtl2: 1.35 },
  { month: "Sep 2025", onestop: 1.75, rtl2: 1.58 },
  { month: "Oct 2025", onestop: 1.31, rtl2: 1.42 },
  { month: "Nov 2025", onestop: 1.45, rtl2: 1.52 },
  { month: "Jan 2026", onestop: 1.55, rtl2: 1.61 },
];

const genericRxData = [
  { name: "Onestop RX", value: 57.64 },
  { name: "RTL2", value: 22.9 },
  { name: "Other Generics", value: 19.16 },
];
const columns = [
  { title: "Account Name", dataIndex: "accountName" },
  { title: "Account Number", dataIndex: "accountNumber" },
  { title: "GCR %", dataIndex: "gcr" },
  { title: "Net", dataIndex: "net" },
  { title: "Generic", dataIndex: "generic" },
  { title: "Generic RX", dataIndex: "genericRx" },
  { title: "Onestop", dataIndex: "onestop" },
  { title: "Onestop RX", dataIndex: "onestopRx" },
  { title: "RX", dataIndex: "rx" },
  { title: "Brand RX", dataIndex: "brandRx" },
  { title: "GCR Month", dataIndex: "gcrMonth" },
];

const pharmacyData = [
  {
    accountName: "1ST CHOICE PHCY",
    accountNumber: 325992,
    gcr: 7.95,
    net: 71300.05,
    generic: 5669.05,
    genericRx: 5669.05,
    onestop: 3274.60,
    onestopRx: 3274.60,
    rx: 71300.05,
    specialty: 0,
    hiv: 0,
    hivRatio: 0,
    brandRx: 65631.00,
    brand: 65631.00,
    otc: 0,
    returns: 0,
    gcrMonth: 8.35,
  },
  {
    accountName: "1ST PHARMACY",
    accountNumber: 248932,
    gcr: 1.01,
    net: 173478.81,
    generic: 1748.23,
    genericRx: 1748.23,
    onestop: 149.62,
    onestopRx: 149.62,
    rx: 173478.81,
    specialty: 16940.39,
    hiv: 0,
    hivRatio: 0,
    brandRx: 174359.50,
    brand: 174359.50,
    otc: 0,
    returns: 0,
    gcrMonth: 0.77,
  },
  {
    accountName: "30TH AVENUE PHARMACY",
    accountNumber: 771000,
    gcr: 2.57,
    net: 425680.88,
    generic: 10952.07,
    genericRx: 10952.07,
    onestop: 3237.58,
    onestopRx: 3237.58,
    rx: 425680.88,
    specialty: 33935.18,
    hiv: 0,
    hivRatio: 0,
    brandRx: 414728.81,
    brand: 414728.81,
    otc: 0,
    returns: 0,
    gcrMonth: 1.61,
  },
  {
    accountName: "A & M DRUGSTORE",
    accountNumber: 247938,
    gcr: 1.05,
    net: 50293.48,
    generic: 518.32,
    genericRx: 518.32,
    onestop: 420.82,
    onestopRx: 420.82,
    rx: 50293.48,
    specialty: 20740.51,
    hiv: 0,
    hivRatio: 0,
    brandRx: 49775.16,
    brand: 49775.16,
    otc: 0,
    returns: 0,
    gcrMonth: 3.35,
  },
  {
    accountName: "A & S PHARMACY INC",
    accountNumber: 825551,
    gcr: 4.99,
    net: 260971.17,
    generic: 1301.63,
    genericRx: 1301.63,
    onestop: 401.08,
    onestopRx: 401.08,
    rx: 260971.17,
    specialty: 837.57,
    hiv: 0,
    hivRatio: 0,
    brandRx: 24795.54,
    brand: 24795.54,
    otc: 0,
    returns: 0,
    gcrMonth: 7.18,
  },
  {
    accountName: "A AND V PHARMACY",
    accountNumber: 275600,
    gcr: 0.00,
    net: 902.29,
    generic: 0,
    genericRx: 0,
    onestop: 0,
    onestopRx: 0,
    rx: 902.29,
    specialty: 0,
    hiv: 0,
    hivRatio: 0,
    brandRx: 902.29,
    brand: 902.29,
    otc: 0,
    returns: 0,
    gcrMonth: 0.00,
  },
  {
    accountName: "A FAMILY PHCY",
    accountNumber: 491858,
    gcr: 5.41,
    net: 51726.52,
    generic: 2799.43,
    genericRx: 2799.43,
    onestop: 448.03,
    onestopRx: 448.03,
    rx: 51726.52,
    specialty: 0,
    hiv: 0,
    hivRatio: 0,
    brandRx: 48927.09,
    brand: 48927.09,
    otc: 0,
    returns: 0,
    gcrMonth: 4.67,
  },
  {
    accountName: "ABE'S DRUG STORE 10",
    accountNumber: 300014,
    gcr: 28.60,
    net: 23650.95,
    generic: 6764.08,
    genericRx: 6764.08,
    onestop: 6266.93,
    onestopRx: 6266.93,
    rx: 23650.95,
    specialty: 837.57,
    hiv: 0,
    hivRatio: 0,
    brandRx: 16886.87,
    brand: 16886.87,
    otc: 0,
    returns: 0,
    gcrMonth: 31.58,
  },
];


const COLORS = ["#1f2a6d", "#e53935", "#6fa8dc"];

const PowerBiSales = () => {
  return (
    <>
     <HeaderCompo initialColor="#000833" />
    <div className="px-4 min-h-screen">
      <Row gutter={[16, 16]} className="mb-8 pt-5">
         <Col xs={24} md={12}>
          <Card
            title={
              <div className="flex justify-between items-center">
                <span className="cardtitle">
                   3 and 6 Month Performanc
                </span>
                <div className="flex items-center gap-2">
                  <InfoCircleOutlined className="mr-2" />
                  <MoreOutlined />
                </div>
              </div>
            }
            className="bg-white h-full CardShadow cardAni"
          >
            <div className="w-full overflow-x-auto">
                  <div className="min-w-[900px] md:min-w-full">
                    {/* <ResponsiveContainer width="100%" height={500}> */}
                      <img src={powerBiImage1} />
                    {/* </ResponsiveContainer> */}
                  </div>
                </div>
          </Card>
        </Col>

        <Col xs={24} md={12}>
          <Card
            title={
              <div className="flex justify-between items-center">
                <span className="cardtitle">
                  Bottom 20% Report
                </span>
                <div className="flex items-center gap-2">
                  <InfoCircleOutlined className="mr-2" />
                  <MoreOutlined />
                </div>
              </div>
            }
            className="bg-white h-full CardShadow cardAni"
          >
            <div className="w-full overflow-x-auto">
                  <div className="min-w-[900px] md:min-w-full">
                    {/* <ResponsiveContainer width="100%" height={500}> */}
                      <img src={powerBiImage2} />
                    {/* </ResponsiveContainer> */}
                  </div>
                </div>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} className="mb-8 pt-5">
         <Col xs={24} md={12}>
          <Card
            title={
              <div className="flex justify-between items-center">
                <span className="cardtitle">
                  Impact Report for COGS and Rebates
                </span>
                <div className="flex items-center gap-2">
                  <InfoCircleOutlined className="mr-2" />
                  <MoreOutlined />
                </div>
              </div>
            }
            className="bg-white h-full CardShadow cardAni"
          >
            <div className="w-full overflow-x-auto">
                  <div className="min-w-[900px] md:min-w-full">
                    {/* <ResponsiveContainer width="100%" height={500}> */}
                      <img src={powerBiImage3} />
                    {/* </ResponsiveContainer> */}
                  </div>
                </div>
          </Card>
        </Col>

        <Col xs={24} md={12}>
          <Card
            title={
              <div className="flex justify-between items-center">
                <span className="cardtitle">
                  Missed Opportunity Report
                </span>
                <div className="flex items-center gap-2">
                  <InfoCircleOutlined className="mr-2" />
                  <MoreOutlined />
                </div>
              </div>
            }
            className="bg-white h-full CardShadow cardAni"
          >
            <div className="w-full overflow-x-auto">
                  <div className="min-w-[900px] md:min-w-full">
                    {/* <ResponsiveContainer width="100%" height={500}> */}
                      <img src={powerBiImage4} />
                    {/* </ResponsiveContainer> */}
                  </div>
                </div>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} className="mb-8 pt-5">
         <Col xs={24} md={12}>
          <Card
            title={
              <div className="flex justify-between items-center">
                <span className="cardtitle">
                  Rebate Impact Report sGCR
                </span>
                <div className="flex items-center gap-2">
                  <InfoCircleOutlined className="mr-2" />
                  <MoreOutlined />
                </div>
              </div>
            }
            className="bg-white h-full CardShadow cardAni"
          >
            <div className="w-full overflow-x-auto">
                  <div className="min-w-[900px] md:min-w-full">
                    {/* <ResponsiveContainer width="100%" height={500}> */}
                      <img src={powerBiImage5} />
                    {/* </ResponsiveContainer> */}
                  </div>
                </div>
          </Card>
        </Col>

        <Col xs={24} md={12}>
          <Card
            title={
              <div className="flex justify-between items-center">
                <span className="cardtitle">
                  Rebate Impact Report GPR
                </span>
                <div className="flex items-center gap-2">
                  <InfoCircleOutlined className="mr-2" />
                  <MoreOutlined />
                </div>
              </div>
            }
            className="bg-white h-full CardShadow cardAni"
          >
            <div className="w-full overflow-x-auto">
                  <div className="min-w-[900px] md:min-w-full">
                    {/* <ResponsiveContainer width="100%" height={500}> */}
                      <img src={powerBiImage6} />
                    {/* </ResponsiveContainer> */}
                  </div>
                </div>
          </Card>
        </Col>
      </Row>




      <Row gutter={[16, 16]} className="mb-8 pt-5">
        <Col xs={24} md={12}>
          <Card
            title={
              <div className="flex justify-between items-center">
                <span className="cardtitle">
                  Previous 11 Month Net Sales and GCR
                </span>
                <div className="flex items-center gap-2">
                  <InfoCircleOutlined className="mr-2" />
                  <MoreOutlined />
                </div>
              </div>
            }
            className="bg-white h-full CardShadow cardAni"
          >
            <Row gutter={16}>
              {/* Chart Section */}
              <Col span={24}>
                <div className="w-full overflow-x-auto">
                  <div className="min-w-[900px] md:min-w-full">
                    <ResponsiveContainer width="100%" height={500}>
                      <ComposedChart data={data}>
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />

                        <XAxis dataKey="month" />

                        <YAxis yAxisId="left" tickFormatter={(v) => `${v}M`} />

                        <YAxis
                          yAxisId="right"
                          orientation="right"
                          tickFormatter={(v) => `${v}%`}
                        />

                        <Tooltip />
                        {/* <Legend
  verticalAlign="top"
  align="left"
  content={() => (
    <div className="flex items-center px-4 mb-3" style={{marginTop:"-8px"}}>
      
      <div className="flex items-center gap-2 mr-4">
        <span
          className="inline-block w-2 h-2 rounded-full"
          style={{ backgroundColor: "#1f2a6d" }}
        />
        <span className="text-sm font-medium text-gray-800">
          Net Sales
        </span>
      </div>

      <div className="flex items-center gap-2">
        <span
          className="inline-block w-6 h-[2px]"
          style={{ backgroundColor: "#e53935" }}
        />
        <span className="text-sm font-medium text-gray-800">
          GCR
        </span>
      </div>

    </div>
  )}
/> */}
 {/* <Legend verticalAlign="top" height={36} /> */}
                        {/* Bars */}
                        <Bar
                          yAxisId="left"
                          dataKey="net"
                          barSize={28}
                          radius={[6, 6, 0, 0]}
                          fill="#2c2f5a"
                        />

                        {/* Line */}
                        <Line
                          yAxisId="right"
                          type="monotone"
                          dataKey="gcr"
                          stroke="#e53935"
                          strokeWidth={2.5}
                          dot={{ r: 4, fill: "#e53935" }}
                        />
                      </ComposedChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </Col>

              {/* KPI Panel */}
              <Col span={24}>
                <div className="h-full flex flex-row justify-around items-center border-l pl-4 ">
                  <div className="">
                    <div className="text-red-600 text-3xl font-bold">
                      66.78M
                    </div>
                    <div className="text-gray-500 text-sm">
                      Current Month Net
                    </div>
                  </div>

                  <div className="">
                    <div className="text-blue-700 text-3xl font-bold">
                      6.47%
                    </div>
                    <div className="text-gray-500 text-sm">
                      Current Month GCR
                    </div>
                  </div>

                  <div>
                    <div className="text-red-500 text-3xl font-bold">-467K</div>
                    <div className="text-gray-500 text-sm">MoM Change</div>
                  </div>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col xs={24} md={12}>
          <Card
            title={
              <div className="flex justify-between items-center">
                <span className="cardtitle">
                  Previous 11 Months Net and Generic Units
                </span>
                <div className="flex items-center gap-2">
                  <InfoCircleOutlined className="mr-2" />
                  <MoreOutlined />
                </div>
              </div>
            }
            className="bg-white h-full CardShadow cardAni"
          >
            <Row gutter={16}>
              {/* Chart */}
              <Col span={24}>
                <div className="w-full overflow-x-auto">
                  <div className="min-w-[900px] md:min-w-full">
                    <ResponsiveContainer width="100%" height={500}>
                      <ComposedChart data={unitsData}>
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />

                        <XAxis dataKey="month" />

                        <YAxis
                          yAxisId="left"
                          tickFormatter={(v) => `${v}K`}
                          label={{
                            value: "Net Units",
                            angle: -90,
                            position: "insideLeft",
                          }}
                        />

                        <YAxis
                          yAxisId="right"
                          orientation="right"
                          tickFormatter={(v) => `${v}K`}
                          label={{
                            value: "Generic RX Units",
                            angle: 90,
                            position: "insideRight",
                          }}
                        />

                        <Tooltip formatter={(v) => `${v}K`} />

                        {/* Net Units Line */}
                        <Line
                          yAxisId="left"
                          type="monotone"
                          dataKey="net"
                          stroke="#1f2a6d"
                          strokeWidth={2.5}
                          dot={{ r: 4, fill: "#1f2a6d" }}
                        >
                          {/* <LabelList
              dataKey="net"
              position="top"
              formatter={(v) => `${v}K`}
            /> */}
                        </Line>

                        {/* Generic Units Line */}
                        <Line
                          yAxisId="right"
                          type="monotone"
                          dataKey="generic"
                          stroke="#e53935"
                          strokeWidth={2.5}
                          dot={{ r: 4, fill: "#e53935" }}
                        >
                          {/* <LabelList
              dataKey="generic"
              position="bottom"
              formatter={(v) => `${v}K`}
            /> */}
                        </Line>
                      </ComposedChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </Col>

              {/* KPI Panel */}
              <Col span={24}>
                <div className="h-full flex flex-row justify-around items-center border-l pl-4">
                  <div className="">
                    <div className="text-red-600 text-3xl font-bold">467K</div>
                    <div className="text-gray-500 text-sm">
                      Current Month Net Units
                    </div>
                  </div>

                  <div className="">
                    <div className="text-blue-700 text-3xl font-bold">217K</div>
                    <div className="text-gray-500 text-sm">
                      Current Month Generic Units
                    </div>
                  </div>

                  <div>
                    <div className="text-purple-700 text-3xl font-bold">
                      728K
                    </div>
                    <div className="text-gray-500 text-sm">Total Units</div>
                  </div>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} className="mb-8 pt-5">
        <Col xs={24} md={12}>
          <Card
            title={
              <div className="flex justify-between items-center">
                <span className="cardtitle">Onestop Ratio by Month</span>
                <div className="flex items-center gap-2">
                  <InfoCircleOutlined className="mr-2" />
                  <MoreOutlined />
                </div>
              </div>
            }
            className="bg-white h-full CardShadow cardAni"
          >
            <Row gutter={16}>
              {/* Chart */}
              <Col span={24}>
                <div className="w-full overflow-x-auto">
                  <div className="min-w-[900px] md:min-w-full">
                    <ResponsiveContainer width="100%" height={420}>
                      <ComposedChart data={onestopData}>
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />

                        <XAxis dataKey="month" />

                        {/* Left Axis */}
                        <YAxis
                          yAxisId="left"
                          tickFormatter={(v) => `${v}%`}
                          label={{
                            value: "Onestop Ratio",
                            angle: -90,
                            position: "insideLeft",
                          }}
                        />

                        {/* Right Axis */}
                        <YAxis
                          yAxisId="right"
                          orientation="right"
                          tickFormatter={(v) => `${v}%`}
                          label={{
                            value: "RTL2 Measure",
                            angle: 90,
                            position: "insideRight",
                          }}
                        />

                        <Tooltip formatter={(v) => `${v}%`} />

                        <Legend verticalAlign="top" height={36} />

                        {/* Onestop Ratio Line */}
                        <Line
                          yAxisId="left"
                          type="monotone"
                          dataKey="onestop"
                          name="Onestop Ratio"
                          stroke="#1f2a6d"
                          strokeWidth={2.5}
                          dot={{ r: 4 }}
                        />

                        {/* RTL2 Measure Line */}
                        <Line
                          yAxisId="right"
                          type="monotone"
                          dataKey="rtl2"
                          name="RTL2 Measure"
                          stroke="#e53935"
                          strokeWidth={2.5}
                          dot={{ r: 4 }}
                        />
                      </ComposedChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </Col>

              {/* Footer label (as in image) */}
              <Col span={24}>
                <div className="text-center text-gray-600 font-medium mt-2">
                  Unique Advantage Customer Access
                </div>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col xs={24} md={12}>
          <Card
            title={
              <div className="flex justify-between items-center">
                <span className="cardtitle">
                  Generic RX Purchase Percentages
                </span>
                <div className="flex items-center gap-2">
                  <InfoCircleOutlined className="mr-2" />
                  <MoreOutlined />
                </div>
              </div>
            }
            className="bg-white h-full CardShadow cardAni"
          >
            <Row>
              <Col span={24}>
                <div className="w-full overflow-x-auto">
                  <div className="min-w-[420px]">
                    <ResponsiveContainer width="100%" height={380}>
                      <PieChart>
                        <Pie
                          data={genericRxData}
                          cx="50%"
                          cy="50%"
                          innerRadius={70} // donut style (optional)
                          outerRadius={120}
                          paddingAngle={2}
                          dataKey="value"
                          label={({ value }) => `${value}%`}
                        >
                          {genericRxData.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={COLORS[index % COLORS.length]}
                            />
                          ))}
                        </Pie>

                        <Tooltip formatter={(v) => `${v}%`} />
                        <Legend
                          verticalAlign="middle"
                          align="right"
                          layout="vertical"
                          iconType="circle"
                        />
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      {/* <div>
        <Table
        columns={columns}
        dataSource={pharmacyData}
        />
      </div> */}
    </div>
    </>
  );
};

export default PowerBiSales;
